import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var validate = function validate(t) {
  return function (values, name, value) {
    var errors = {};
    var emailTest = /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm;
    if (!values) {
      if (name === "name" && !value.trim()) {
        errors.name = t("يجب ادخال الاسم");
      } else if (name === "name" && value.trim().length < 2) {
        errors.name = t("يجب أن يتكون من 2 حروف أو أكثر  الاسم الكامل");
      }
      if (name === "phone" && !value.trim()) {
        errors.phone = t("يجب ادخال رقم الموبايل");
      } else if (name === "phone" && isNaN(value)) {
        errors.phone = t("يجب ادخال ارقام فقط");
      } else if (name === "phone" && value.trim().length !== 10) {
        errors.phone = t("يجب ان يكون الرقم من عشرة خانات");
      } else if (name === "phone" && !/^(05)[0-9]{8}$/.test(value)) {
        errors.phone = t("يجب أن يبدأ رقم الجوال ب  05");
      }
      if (name === "email" && !value.trim()) {
        errors.email = t("يجب ادخال البريد الالكتروني");
      } else if (name === "email" && !emailTest.test(value)) {
        errors.email = t("يجب ادخال بريد الكتروني صحيح");
      }
      if (name === "subject") {
        if (!value.trim()) {
          errors.subject = t("يجب ادخال عنوان الرسالة");
        } else if (value.length > 40) {
          errors.subject = t("يجب أن يتكون من 40 حرف أو أقل عنوان الرسالة");
        }
      }
      if (name === "body" && !value.trim()) {
        errors.body = t("يجب ادخال نص الرسالة");
      } else if (name === "body" && value.trim().length < 10) {
        errors.body = t("يجب أن يتكون من 10 حروف أو أكثر  موضوع الاستفسار");
      }
    } else {
      if (!values.name.trim()) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          name: t("يجب ادخال الاسم")
        });
      } else if (values.name.trim().length < 2) {
        errors.name = t("يجب أن يتكون من 2 حروف أو أكثر  الاسم الكامل");
      }
      if (!values.phone.trim()) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          phone: t("يجب ادخال رقم الموبايل")
        });
      } else if (values.phone.length !== 10) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          phone: t("يجب ان يكون الرقم من عشرة خانات")
        });
      } else if (isNaN(values.phone)) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          phone: t("يجب ادخال ارقام فقط")
        });
      } else if (!/^(05)[0-9]{8}$/.test(values.phone)) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          phone: t("يجب أن يبدأ رقم الجوال ب  05")
        });
      }
      if (!values.email.trim()) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          email: t("يجب ادخال البريد الالكتروني")
        });
      } else if (!emailTest.test(values.email)) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          email: t("يجب ادخال بريد الكتروني صحيح")
        });
      }
      if (!values.subject.trim()) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          subject: t("يجب ادخال عنوان الرسالة")
        });
      } else if (values.subject.length > 40) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          subject: t("يجب أن يتكون من 40 حرف أو أقل عنوان الرسالة")
        });
      }
      if (!values.body.trim()) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          body: t("يجب ادخال نص الرسالة")
        });
      } else if (values.body.trim().length < 10) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          body: t(" يجب أن يتكون من 10 حروف أو أكثر  موضوع الاستفسار")
        });
      }
    }
    return errors;
  };
};
export default validate;